export const setWithdrawData = (data) => ({
    type:"SET_WITHDRAW_DATA",
    data
})